<div class="div_loading">
  <div class="my-container" [hidden]="!loading">
    <mat-progress-bar mode="indeterminate"></mat-progress-bar>
  </div>
</div>

<mat-drawer-container autosize style="background-color: transparent">

  <mat-drawer #drawer mode="side" opened style="min-width:3rem;max-width:13rem;background:#fff">
    <div class="nav_button cursor" (click)="open_show_extra_menu()" [ngClass]="{nav2:show_extra_menu}">
      <span class="material-icons" style="font-size:1.5rem">
        reorder
      </span>
    </div>


    <div class="row nav1" style="min-width:13rem;padding-bottom: 1rem;" *ngIf="show_extra_menu">
      <input type="file" name="image" accept="image/*" (change)="change_avater($event)" #logo style="display: none;">
      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12" style="margin-bottom:2rem">
        <div [ngStyle]="{'background-image':'url( ' + user_logo + ')'}" class="nav_avatar cursor"
          (click)="logo.click()">
        </div>
        <div class="pe1 nav3" (click)="get_group()">
          <div class="online blink"></div>{{ user_title }}
        </div>
      </div>

      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pe1 div1 cursor" *ngFor="let x of list_ckd_status"
        (click)="open_status_ckd(x.ckd_status_id)" [ngClass]="{activeStatus:x.ckd_status_id == ckd_status_id}"
        style="padding-left:25px;">
        {{ x.ckd_status_title }}
        <span class="count">{{ x.count }}</span>
      </div>

      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pe1 div1 cursor" *ngFor="let x of list_process"
        (click)="open_process(x.sale_process_id)" [ngClass]="{activeStatus:x.sale_process_id == process_id}"
        style="padding-left:25px;">
        {{ x.sale_process_title }}
        <span class="count">{{ x.count }}</span>
      </div>


      <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pe1 div1 cursor" *ngFor="let x of list_ckd"
        [ngClass]="{activeStatus:x.site_ckd_id  == ckd_id}">
        <span (click)="go_to_ckd(x.site_ckd_id)">{{ x.title | substr:0:25 }}</span>
        <span class="count" [matMenuTriggerFor]="menu"
          (click)="get_menu1(x.site_ckd_id,x.user_sex_title,x.customer_title,x.customer_cellphone,x.site_ckd_token,x.ckd_status_title)"><i
            class="fas fa-info-circle icon"></i></span>
      </div>

      <mat-menu #menu="matMenu" class="ckd-mat-menu-panel" xPosition="before">
        <table class="table table-bordered" (click)="$event.stopPropagation()">
          <tr>
            <td style="background-color: #0cf729">
              <a class="cursor">
                {{ status_title }}
              </a>
            </td>
          </tr>
          <tr>
            <td>
              <a class="cursor" (click)="open_ckd(ckd_id)">
                جزئیات فاکتور
              </a>
            </td>
          </tr>
          <tr>
            <td>
              <a [href]="serverService.get_currenct_site()+'/ckd-letter/'+token" target="_blank">
                نامه
              </a>
            </td>
          </tr>
          <tr>
            <td>
              <a [href]="serverService.get_currenct_site()+'/ckd-list/'+token" target="_blank">
                متریال
              </a>
            </td>
          </tr>
          <tr>
            <td>
              <a [href]="serverService.get_currenct_site()+'/tr-ckd/'+token" target="_blank">
                فاکتور
              </a>
            </td>
          </tr>
        </table>
      </mat-menu>

      <div class="row" style="margin-top:2rem" *ngIf="list_group.length > 0">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pe1 div1 cursor" *ngFor="let x of list_group"
          (click)="go_to_group(x.user_groups_id)" [routerLinkActive]="['activeStatus']" style="padding-left:25px;"
          [ngClass]="{activeStatus:group_id == x.user_groups_id}">
          {{ x.title }}
          <span class="count">{{ x.count }}</span>
        </div>
      </div>

      <div class="row" style="margin-top:2rem" *ngIf="list_cate.length > 0">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pe1 div1 cursor" *ngFor="let x of list_cate"
          (click)="go_to_cate(x.id)" style="padding-left:25px;" [routerLinkActive]="['activeStatus']"
          [ngClass]="{activeStatus:cate_id == x.id }">
          {{ x.title | substr:0:25 }}
          <span class="count">{{ x.count }}</span>
        </div>
      </div>

      <div class="row" style="margin-top:2rem" *ngIf="list_invoice_type.length > 0">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 pe1 div1 cursor"
          *ngFor="let x of list_invoice_type" (click)="go_invoice_type(x.wharehouse_invoice_type_id)"
          style="padding-left:25px;" [routerLinkActive]="['activeStatus']"
          [ngClass]="{activeStatus:group_id == x.wharehouse_invoice_type_id}">
          {{ x.wharehouse_invoice_type_title }}
          <span class="count">{{ x.count }}</span>
        </div>
      </div>




    </div>

    <div *ngIf="!show_extra_menu">
      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 nav_thumb">
          <img src="https://www.gravatar.com/avatar/7f286fe9ca0faebf1c68d4e2763b279e/?s=128&r=g&d=mm" alt="Avatar"
            class="nav_avatar_thumb">
        </div>
      </div>

      <div class="row">
        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 nav_thumb nav_setting">
          <span class="material-icons cursor" (click)="access_setting_menu()" *ngIf="setting_menu == false">
            settings
          </span>

          <span class="material-icons cursor" (click)="access_setting_menu()" *ngIf="setting_menu == true">
            highlight_off
          </span>
        </div>

        <div class="col-xl-12 col-lg-12 col-md-12 col-sm-12 col-xs-12 nav_thumb nav_exit" (click)="signout()">
          <span class="material-icons cursor">
            settings_power
          </span>
        </div>
      </div>

    </div>
  </mat-drawer>

  <mat-drawer-content>
    <div style="width:100%;min-height:5px;background:#d93025;" class="spinner"></div>
    <div style="position:absolute;left:0;width:15rem !important" class="software1 mat-menu-content1">
      <span [hidden]="true"></span>
      <mat-menu #menu="matMenu">
        <div class="row">
          <a *ngFor="let x of list_software" href="{{ x.site_software_link }}">
            <div class="col-lg-4 col-xl-4 col-md-4 software_div cursor">
              <div class="software_logo" [ngStyle]="{'background-image':'url( ' + x.logo + ')'}"></div>
              <div class="software_text">{{ x.title }}</div>
            </div>
          </a>
        </div>
      </mat-menu>
    </div>
    <nav data-role="ribbonmenu" class="ribbon_pe" [ngClass]="{ribbon_en:lang == 2}">

      <ul class="tabs-holder">
        <span *ngFor="let x of list_tab;let i = index" [ngClass]="{active:i == 0}" (click)="select(x.site_tab_id)"
          id="a{{ x.site_tab_id }}">
          <li *ngIf="x.show == true" [ngStyle]="{'background':x.site_tab_color,'color':'#fff'}">
            <a href="#{{ x.site_tab_id }}">
              {{ x.site_tab_title }}
            </a>
          </li>
        </span>


        <span (click)="open_add_section()" class="cursor" [hidden]="setting_menu == false" style="margin-right: 5px;"><i
            class="fas fa-plus"></i></span>
      </ul>
      <div (click)="go_to_user()" style="position: absolute;left:15px;top:3px;z-index:99999999" *ngIf="refrerr == 2">
        <i class="fas fa-arrow-alt-circle-left icon back"></i>
      </div>
      <div class="content-holder">
        <div class="section" *ngFor="let y of list_tab;let i = index" id="{{ y.site_tab_id }}"
          [ngClass]="{active:i == 0}">
          <div class="group">
            <span *ngFor="let x of list_tab_temp[y.site_tab_id];let i = index">
              <span *ngIf="list_menus[x.site_section_id] && list_menus[x.site_section_id].length > 0">
                <section>
                  <div class="group flex-column" style="border-left:solid 1px #ccc;">
                    <span *ngFor="let xx of list_menus[x.site_section_id];let menu = index">
                      <mat-card class="example-card pe1 example-header-image service_card_logo cursor"
                        (click)="open_menu(menu,xx.shop_services_link,xx.shop_services_id,xx.shop_services_title,x.site_section_id)"
                        [ngClass]="{active_menu:menu_id == xx.shop_services_id}">
                        <div class="mat-card-avatar service_logo" mat-card-avatar
                          [ngStyle]="{'background-image':'url( ' + xx.src + ')'}"></div>
                        <div class="service_text">{{ xx.shop_services_title }}</div>
                      </mat-card>
                    </span>
                    <span class="title cursor section_title">
                      {{ x.site_section_title }}
                    </span>
                  </div><!-- group flex-column -->
                  <div class="group-divider"></div>
                </section>
              </span>

            </span>




          </div>
        </div>
      </div>

    </nav>
    <!-- *********************************************************************************************************** -->
    <!--
      <ngx-smart-modal #myModalPassword identifier="myModalPassword" class="pe" [ngClass]="{en:lang==2}">
          <div style='text-align:center;padding:12px !important' *ngIf="lang == 1 ">تغییر پسورد</div>
          <div style='text-align:center;padding:12px !important' *ngIf="lang == 2 ">Change Password</div>
          <div style='padding:12px !important'>
              <div style='margin-top:20px'>

                  <div class='col-md-6 en' *ngIf="lang == 2 ">
                      <label for="title" class='wh-label'> password :
                          <input class='wh-input' type="password" name='password' [(ngModel)]='password' tabindex="1"
                              [ngClass]="{warning_form:password_validation}" autocomplate=off>
                      </label>
                  </div>
                  <div class='col-md-6 en' *ngIf="lang == 2 ">
                      <label for="title" class='wh-label'> confirm password :
                          <input class='wh-input' type="password" name='repassword' [(ngModel)]='repassword'
                              tabindex="2" [ngClass]="{warning_form:repassword_validation}" autocomplate=off>
                      </label>
                  </div>

                  <div class='col-md-6 pe' *ngIf="lang == 1 ">
                      <label for="title" class='wh-label'> رمز عبور :
                          <input class='wh-input' type="password" name='password' [(ngModel)]='password' tabindex="1"
                              [ngClass]="{warning_form:password_validation}" autocomplate=off>
                      </label>
                  </div>
                  <div class='col-md-6 pe' *ngIf="lang == 1 ">
                      <label for="title" class='wh-label'> تکرار رمز عبور :
                          <input class='wh-input' type="password" name='repassword' [(ngModel)]='repassword'
                              tabindex="2" [ngClass]="{warning_form:repassword_validation}" autocomplate=off>
                      </label>
                  </div>


                  <div class='col-md-12 en' style='margin-top:5px;text-align:center' *ngIf="lang == 2 ">
                      <button class="btn" tabindex=3 (click)="change_password()">Change password</button>
                  </div>

                  <div class='col-md-12 pe' style='margin-top:5px;text-align:center' *ngIf="lang == 1 ">
                      <button class="btn" tabindex=3 (click)="change_password()">تغییر رمز عبور</button>
                  </div>

                  <div class='col-md-12' *ngIf="err_password">
                      <span *ngIf="lang == 1" class='pe'>{{ err_password_message }}</span>
                      <span *ngIf="lang == 2" class="en">{{ err_password_message }}</span>
                  </div>

              </div>
          </div>
      </ngx-smart-modal>
      -->
    <!-- *********************************************************************************************************** -->
    <router-outlet></router-outlet>


    <div class="version pe" *ngIf="version_show_alarm == true">
      آپدیت جدید نرم افزار رسید.برای دریافت نسخه جدید لطفا یک بار رفرش و دوباره لاگین شوید . می توانید از
      <span class="cursor" (click)="change_version()">اینجا</span>
      اقدام نمائید.
    </div>


  </mat-drawer-content>


</mat-drawer-container>